import type { JSX } from "react";
import type { IconName } from "@similarweb/icons";
import noop from "lodash/noop";

import { StyledRadioButton } from "app/components/React/RadioSelect/styledComponents";
import { Wrapper, Container, LabelContainer, TitleContainer, Icon, Title, Subtitle } from "./SharingModalOption.styled";

interface ISharingDashboardOptionProps {
    isSelected: boolean;
    onClick: VoidFunction;
    iconName: IconName;
    title: string;
    subTitle: string;
    isDisabled: boolean;
}

export const SharingModalOption = ({
    isSelected,
    onClick,
    iconName,
    title,
    subTitle,
    isDisabled,
}: ISharingDashboardOptionProps): JSX.Element => {
    const handleClick = (): void => {
        isDisabled ? noop : onClick();
    };

    return (
        <Wrapper
            isDisabled={isDisabled}
            onClick={handleClick}
        >
            <Container
                isDisabled={isDisabled}
                alignItems="flex-start"
            >
                <StyledRadioButton itemSelected={isSelected} />
                <LabelContainer>
                    <TitleContainer>
                        <Icon
                            iconName={iconName}
                            size="xs"
                        />
                        <Title>{title}</Title>
                    </TitleContainer>
                    <Subtitle>{subTitle}</Subtitle>
                </LabelContainer>
            </Container>
        </Wrapper>
    );
};
